import { Component, EventEmitter, Input, Output } from '@angular/core';
import { environment } from '../../../environments/environment';
import { ManualRefreshService } from "../../services/manual-refresh/manual-refresh.service";

import { HttpErrorResponse } from '@angular/common/http';
import { CVANotificationService } from '../../services/cva-notification/cva-notification.service';
import { CVA_CONSTANTS, MANUAL_REFRESH_IDENTIFIER } from '../../util/constants';
import { NotificationClassEnum } from '../../models/notification-class.enum';
import { AdditionalData, ManualResponse, RecordResponse } from '../../models/manual-refresh.interface';

@Component({
    standalone: false,
    selector: 'cva-manual-refresh',
    templateUrl: './manual-refresh.component.html',
    styleUrl: './manual-refresh.component.scss',
    
})
export class ManualRefreshComponent {
  @Input() id!: string;
  @Input() identifier!: MANUAL_REFRESH_IDENTIFIER;
  @Input() additionalData!: AdditionalData;

  @Output() dataFetched = new EventEmitter<ManualResponse<RecordResponse>>();

  cvaUI_url = environment.cvaUI_url;
  isRefreshing = false;

  constructor(
    private readonly  apiService: ManualRefreshService,
    private readonly  cvaNotificationService: CVANotificationService,
  ) { }

  refreshRecords() {
    this.isRefreshing = true;
    this.fetchRecords()
    setTimeout(() => {
      this.isRefreshing = false;
    }, 1000);
  }

  fetchRecords() {
    this.apiService.getRefreshedData<ManualResponse<RecordResponse>>(
      this.id,
      this.identifier,
      this.additionalData
    ).subscribe({
      next: (res: { response: ManualResponse<RecordResponse> }) => {
        this.dataFetched.emit(res.response)
      },
      error: (errorResponse: HttpErrorResponse) => {
        let errorMessage: string = '';
        if (errorResponse.error?.error) {
          errorMessage = errorResponse.error.error.errorMessage;
        }
        this.cvaNotificationService.showNotification(
          errorMessage || CVA_CONSTANTS.MESSAGE.MANUAL_ERR,
          NotificationClassEnum.ERROR
        );
      }
    });
  }
}
